var $ = require('jquery')
  , ERROR_MSG = '网络发生了错误'
  , openAlert = require('game-info/widgets/openAlert')
  , ActivityForm = require('game-info/widgets/ActivityForm')
  , voteSuccessTmpl = require('./voteSuccessTmpl.handlebars')
  , fetchActivityInfo = require('game-info/mods/fetchActivityInfo')

function submitVoteInfo(gameCode) {
  var dfd = new $.Deferred()

  $.ajax({
    type: 'POST'
  , url: '/game-vote.html'
  , dataType:'json'
  , data: { id : gameCode }
  }).done(function(resp) {
    dfd.resolve(resp)
  }).fail(dfd.reject)

  return dfd.promise()
}

module.exports = function(e) {
  var ued = window.ued || {}
    , gameCode = ued.gameCode
  $.when(fetchActivityInfo(gameCode), submitVoteInfo(gameCode))
    .done(function(activityInfo, voteResult) {
      // console.log(gameCode,activityInfo)
      if (activityInfo && activityInfo.begin_time) {
        var formDiaog = new ActivityForm({
          activityInfo: activityInfo
        , resultMessage: voteSuccessTmpl()
        })

        formDiaog.render().open()
        return
      }

      if (voteResult.result === 'failure') {
        return openAlert({ content: voteResult.msg || ERROR_MSG })
      }

      openAlert({ title: '投票成功', html: voteSuccessTmpl })
    })
    .fail(function() { openAlert({ content: ERROR_MSG }) })
}
